import { getListIdForFilters } from '../helper';
import { DEFAULT_SESSION_ID } from '../constants';
// ACCIONES DE LISTADO DE VISITAS
export const efectorlistActions = {

    LOAD_EFECTORES:'LOAD_EFECTORES',
    LOAD_EFECTORES_BY_PRACTICE:'LOAD_EFECTORES_BY_PRACTICE',
    LOAD_EFECTORES_NEXT:'LOAD_EFECTORES_NEXT',
    LOAD_EFECTORES_PREV:'LOAD_EFECTORES_PREV',
    UPDATE_PAGINATION:'UPDATE_PAGINATION',

    FETCH_EFECTORES_SUCCESS:'FETCH_EFECTORES_SUCCESS',
    FETCH_EFECTORES_FAILED:'FETCH_EFECTORES_FAILED',
    FETCH_EFECTORES_PENDING:'FETCH_EFECTORES_PENDING',

    fetchEfectoresSuccess: (efectorListId, {data}) => ({
      type: efectorlistActions.FETCH_EFECTORES_SUCCESS,
      payload: {
        efectorListId: efectorListId,
        data
      }
    }),

    fetchEfectoresFailed: error =>({
        type:efectorlistActions.FETCH_EFECTORES_FAILED,
        payload: error
    }),

    fetchEfectoresPending: efectorListId =>({
        type:efectorlistActions.FETCH_EFECTORES_PENDING,
        payload:{
          efectorListId
        }
    }),

    loadEfectores: (filters, efectorListId) => {
      let new_filters = filters.toJS()
      return ({
        type: efectorlistActions.LOAD_EFECTORES,
        payload: {
          efectorListId: DEFAULT_SESSION_ID, //(efectorListId) ? efectorListId : getListIdForFilters(new_filters),
          filters: new_filters,
        }
      })
    },

    loadEfectoresByPractice: (filters, efectorListId) => {

      let new_filters = filters.toJS()
      return ({
        type: efectorlistActions.LOAD_EFECTORES_BY_PRACTICE,
        payload: {
          efectorListId: DEFAULT_SESSION_ID, //(efectorListId) ? efectorListId : getListIdForFilters(new_filters),
          filters: new_filters,
        }
      })
    },


    loadNextResults: () => ({
      type: efectorlistActions.LOAD_EFECTORES_NEXT
    }),

    loadPrevResults: () => ({
      type: efectorlistActions.LOAD_EFECTORES_PREV
    }),

    updatePagination: page => ({
      type: efectorlistActions.UPDATE_PAGINATION,
      payload: {
        page
      }
    })
}

export const efectorlistRequestActions = {
    failed: efectorlistActions.fetchEfectoresFailed,
    success: efectorlistActions.fetchEfectoresSuccess,
    pending: efectorlistActions.fetchEfectoresPending
}
